import React, { useState } from 'react';
import WrittenQuiz from './WrittenQuiz';
import PensumQuiz from './PensumQuiz';
import WordsQuiz from './WordsQuiz';
import './App.css';

function Judolingo() {
    const [mode, setMode] = useState<'WrittenQuiz' | 'PensumQuiz' | 'WordsQuiz'>('WrittenQuiz');
    const [points, setPoints] = useState(0);
    // Remove mode selection buttons, auto-switch mode, and end after 35 answers
    const modeOrder: Array<'WrittenQuiz' | 'PensumQuiz' | 'WordsQuiz'> = ['WrittenQuiz', 'PensumQuiz', 'WordsQuiz'];
    const [answerCount, setAnswerCount] = useState(0);
    const [ended, setEnded] = useState(false);
    const nextMode = (current: typeof mode) => {
        const idx = modeOrder.indexOf(current);
        return modeOrder[(idx + 1) % modeOrder.length];
    };

    // Handler to be passed to quiz components
    const handleNextMode = () => {
        setAnswerCount((prev) => {
            const next = prev + 1;
            if (next >= 35) {
                setEnded(true);
            } else {
                setMode((prevMode) => nextMode(prevMode));
            }
            return next;
        });
    };

    // Handler to update points
    const handleScore = (score: number) => {
        setPoints((prev) => prev + score);
    };

    return (
        <div className="quiz-container">
            <button className="close-button" onClick={() => window.history.back()}>&times;</button>
            <h2 className="quiz-title">Judolingo</h2>
            <div style={{ fontWeight: 'bold', marginBottom: '1rem', fontSize: '1.2rem' }}>Points: {points}</div>
            <div style={{ marginBottom: '1rem' }}>Answered: {answerCount} / 35</div>
            {ended ? (
                <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                    <h2>Quiz færdig!</h2>
                    <p>Din score: <span style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>{points}</span></p>
                    <p>Tak for spillet!</p>
                </div>
            ) : (
                <div>
                    {mode === 'WrittenQuiz' && <WrittenQuiz key="WrittenQuiz" onNextMode={handleNextMode} onScore={handleScore} />}
                    {mode === 'PensumQuiz' && <PensumQuiz key="PensumQuiz" selectedBelt={'gul'} onNextMode={handleNextMode} onScore={handleScore} />}
                    {mode === 'WordsQuiz' && <WordsQuiz key="WordsQuiz" onNextMode={handleNextMode} onScore={handleScore} />}
                </div>
            )}
        </div>
    );
}

export default Judolingo;
